/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs */

const en_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarded repricing`)
};

const ar_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسعير محمي`)
};

const bn_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সুরক্ষিত পুনর্মূল্য`)
};

const de_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgesichertes Repricing`)
};

const es_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repreciación protegida`)
};

const fr_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repricing protégé`)
};

const pt_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprecificação protegida`)
};

const zh_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带保护的调价`)
};

const tr_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korumalı yeniden fiyatlama`)
};

const ru_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защищённый репрайсинг`)
};

const pl_svc_ecommerce_amazon_tools_reprice_title7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chroniony repricing`)
};

/**
* | output |
* | --- |
* | "Guarded repricing" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_reprice_title7 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Reprice_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_reprice_title7(inputs)
	return en_svc_ecommerce_amazon_tools_reprice_title7(inputs)
});
export { svc_ecommerce_amazon_tools_reprice_title7 as "svc_ecommerce-amazon-tools_REPRICE_title" }